import * as React from 'react';
import type { SVGProps } from 'react';

const DownArrowIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    width={24}
    height={24}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M11.03 5.53 7.97 8.583 4.91 5.53l-.94.94 4 4 4-4z"
      clipRule="evenodd"
    />
  </svg>
);
export { DownArrowIcon as ReactComponent };
